import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { DialogEditMaintenanceComponent } from '../../../../dialog-maintenances.component';
var InfoBannerComponent = /** @class */ (function () {
    function InfoBannerComponent(matDialog, maintenancesApi) {
        this.matDialog = matDialog;
        this.maintenancesApi = maintenancesApi;
        this.isVisible = true;
    }
    InfoBannerComponent.prototype.hideBanner = function () {
        this.isVisible = false;
    };
    InfoBannerComponent.prototype.openPreviousMaintenance = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var maintenance;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.maintenancesApi.searchOne(this.maintenance.id).toPromise()];
                    case 1:
                        maintenance = _a.sent();
                        this.matDialog.open(DialogEditMaintenanceComponent, {
                            panelClass: 'dialog-edit-maintenance',
                            data: {
                                maintenance: maintenance,
                                isViewMode: false,
                                selectedTabIndex: 0,
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return InfoBannerComponent;
}());
export { InfoBannerComponent };
